import styled from "styled-components"
import Button from "../Button"

export const StyledCard = styled.div<{ selected?: boolean }>`
  border: ${({ theme, selected }) => selected ? `2px solid ${theme.colors.primary}` : '1px solid black'};
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.space[3]};
  color: ${({ theme }) => theme.colors.black};
  cursor: pointer;
`

export const StyledTitle = styled.p`
  color: ${({ theme }) => theme.colors.blue};
  font-size: ${({ theme }) => theme.fontSizes.h3};
  font-weight: bold;
`

export const StyledDescription = styled.p``

export const StyledButton = styled(Button)`
  align-self: flex-end;
`
